import { CustomPalette, Palette as MuiPalette, PaletteOptions as MuiPaletteOptions } from '@mui/material/styles';

declare module '@mui/material/styles' {
    interface CustomPalette {
        primary: {
            light: string;
            main: string;
            dark: string;
        };
        info: {
            light: string;
            main: string;
            dark: string;
        };
        common: {
            black: string;
            white: string;
        };
        headings: {
            light: string;
            main: string;
            dark: string;
        };
        border: {
            light: string;
        };
        brand: {
            main: string;
        };
        fonts: {
            black: string;
        };
        muted: {
            muted1: string;
            muted2: string;
            muted3: string;
            muted4: string;
            muted5: string;
            muted6: string;
            muted7: string;
            muted8: string;
        };
        background: {
            default: string;
            paper: string;
            primary: string;
            disabled: string;
        };
        text: {
            primary: string;
            link: string;
        };
        components: {
            divider: string;
            icon: string;
            text: string;
            chipBg: string;
            sideBarBackground: string;
            listingTooltip: string;
            listingTooltipDivider: string;
            button: string;
            buttonHover: string;
            buttonAlt: string;
            buttonAltHover: string;
            switch: string;
            warning: string;
            error: string;
        };
        statistics: {
            green: string;
            yellow: string;
            red: string;
            gray: string;
            purple: string;
            blue: string;
        };
        dots: {
            primary: string;
            green: string;
            red: string;
        };
    }

    // NOTE: Sometimes a ts-error appears, and it should be ignored
    //       - Type 'Palette' recursively references itself as a base type

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    interface Palette extends CustomPalette, MuiPalette {}
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    interface PaletteOptions extends CustomPalette, MuiPaletteOptions {}
}

export const CUSTOM_PALETTE: CustomPalette = {
    primary: {
        light: '#EDF3FD',
        main: '#5389F1',
        dark: '#1557BD',
    },
    info: {
        light: '#22D3EE',
        main: '#06B6D4',
        dark: '#0E7490',
    },
    common: {
        black: '#000000',
        white: '#ffffff',
    },
    headings: {
        light: '#8896A9',
        main: '#64748B',
        dark: '#4D596F',
    },
    border: {
        light: '#CCCCCC',
    },
    brand: {
        main: '#BDCE42',
    },
    fonts: {
        black: 'rgba(0, 0, 0, 0.6)',
    },
    muted: {
        muted1: 'rgba(0, 0, 0, 0.12)',
        muted2: 'rgba(0, 0, 0, 0.23)',
        muted3: 'rgba(0, 0, 0, 0.42)',
        muted4: 'rgba(0, 0, 0, 0.50)',
        muted5: '#F8F8F8',
        muted6: 'rgba(0, 0, 0, 0.38)',
        muted7: 'rgba(0, 0, 0, 0.87)',
        muted8: 'rgba(0, 0, 0, 0.60)',
    },
    background: {
        default: '#F5F5F5',
        paper: '#FFFFFF',
        primary: '#EDF3FD',
        disabled: '#E0E0E0',
    },
    components: {
        divider: '#434959',
        icon: '#A1A4AC',
        text: '#ABAEB6',
        chipBg: '#4B5160',
        sideBarBackground: '#293042',
        listingTooltip: '#293042',
        listingTooltipDivider: 'rgba(255, 255, 255, 0.12)',
        button: '#6897F2',
        buttonHover: '#8AADF5',
        buttonAlt: '#EDF3FD',
        buttonAltHover: '#CDDDF9',
        switch: '#4CAF50',
        warning: '#FDF6CD',
        error: '#d32f2f',
    },
    text: {
        primary: 'rgba(0, 0, 0, 0.87)',
        link: '#3697E9',
    },
    statistics: {
        green: '#4CAF50',
        yellow: '#FF9800',
        red: '#EF5350',
        gray: '#8896A9',
        purple: '#673AB7',
        blue: '#1557BD',
    },
    dots: {
        primary: '#5389F1',
        green: '#3CDA8A',
        red: '#FF6C89',
    },
} as const;
